<script lang="ts">
  import { getContext } from 'svelte'
  import Label from '../components/Label.svelte'
  import Icon from '../components/Icon.svelte'
  import type { Theme } from 'website_script/types/theme'

  const { accentColor, textCtaColor } = getContext<Theme>('theme')

  /** url used to display icon */
  export let iconSrc: string = ''
  /** background color of the icon */
  export let iconBg: string = accentColor
  export let iconColor: string = textCtaColor
  /** label text */
  export let label: string
  /** string with label classnames; Options: with-background|small|label-left */
  export let labelStyle: string = ''
  /** Component and its elements size */
  export let size: string = '60px'
  /** Show or hide label for the drawer item */
  export let showLabel: boolean = true
  export let hasPrompt: boolean = false
  export let showPrompt: boolean = false
  import { createEventDispatcher } from 'svelte'

  const dispatch = createEventDispatcher()
</script>

<div class="auws-drawer-item-wrapper">
  <div class={`auws-icon-wrapper`} on:click={() => dispatch('click')}>
    {#if showLabel && label}
      <Label className={`${labelStyle}`} name={label} />
    {/if}
    <Icon
      {size}
      backgroundColor={iconBg}
      svgProps={{
        fill: iconColor,
        data: iconSrc,
        alt: label,
      }}
    />
  </div>
  {#if hasPrompt && showPrompt}
    <slot />
  {/if}
</div>

<style>
  .auws-drawer-item-wrapper {
    position: relative;
  }
  .auws-icon-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    display: flex;
    flex-direction: column-reverse;
    margin-bottom: 8px;
  }
</style>
